import { Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { LINKS } from "../lib/links";
import { TikTokIcon } from "./PlatformIcons";

export default function Footer() {
  return (
    <footer className="relative z-10 mt-40 border-t border-white/5" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
          <div className="mb-5"><Logo size={34} textClassName="text-lg" /></div>
            <p className="text-zinc-500 text-[15px] max-w-sm leading-relaxed font-light">
              Daily reminders to build discipline, reclaim your identity, and become the person you were meant to be.
            </p>
            <div className="flex gap-5 mt-7">
              <a href={LINKS.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="text-zinc-500 hover:text-[#4da6ff] hover:-translate-y-0.5 transition-[color,transform]"><Facebook className="w-5 h-5" /></a>
              <a href={LINKS.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" data-testid="footer-tiktok" className="text-zinc-500 hover:text-[#4da6ff] hover:-translate-y-0.5 transition-[color,transform]"><TikTokIcon className="w-5 h-5" /></a>
            </div>
            <div className="mt-8 scroll-mt-28" id="contact" data-testid="contact-section">
              <h4 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-3">Contact</h4>
              <a href={`mailto:${LINKS.contactEmail}`} data-testid="footer-contact-email" className="text-sm text-zinc-300 hover:text-[#4da6ff] transition-colors">{LINKS.contactEmail}</a>
              <Link to="/business" className="block text-xs text-zinc-500 hover:text-white mt-2 transition-colors" data-testid="footer-business-inquiries">Business inquiries → For Business</Link>
            </div>
          </div>
          <div>
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-5">Explore</h4>
            <ul className="space-y-3.5 text-[15px] text-zinc-400 font-light">
              <li><Link to="/watch" className="hover:text-white transition-colors">Watch More</Link></li>
              <li><Link to="/resources" className="hover:text-white transition-colors">Resource Library</Link></li>
              <li><Link to="/tools" className="hover:text-white transition-colors">Mindfulness Tools</Link></li>
              <li><Link to="/community" className="hover:text-white transition-colors">Community Wall</Link></li>
              <li><Link to="/dashboard" className="hover:text-white transition-colors">Your Sanctuary</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-5">Account</h4>
            <ul className="space-y-3.5 text-[15px] text-zinc-400 font-light">
              <li><Link to="/login" className="hover:text-white transition-colors">Sign in</Link></li>
              <li><Link to="/register" className="hover:text-white transition-colors">Create account</Link></li>
              <li><Link to="/journal" className="hover:text-white transition-colors">Private Journal</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-600">
          <span>© {new Date().getFullYear()} Spirit Admin</span>
          <span className="tracking-[0.15em] uppercase">Remember who you are</span>
        </div>
      </div>
    </footer>
  );
}
